import ODataTableStorage from '../ODataTable/ODataTableStorage';
import { NOOP } from '../../utils/const';
import { resolveFilter } from './QueryOptions';
import odata from './odata';

export function groupBy(xs, key) {
  return xs.reduce((rv, x) => {
    const newRv = rv;
    (newRv[x[key]] = newRv[x[key]] || []).push(x);
    return newRv;
  }, {});
}

/**
 * La classe gestisce il caricamento da sorgente OData.
 */
class ODataLoader {
  constructor(onChangeState = NOOP) {
    this.onChangeState = onChangeState;
    this.store = new ODataTableStorage();
  }

  getInitialState(pageSize, sortProperty, sortOrder) {
    return {
      loading: false,
      selected: false,
      items: [],
      count: 0,
      currentPage: 0,
      pageSize: pageSize || 20,
      sortProperty,
      sortOrder,
      totalPages: 0,
      filter: {},
    };
  }

  /**
   * Assegna i risultati di un caricamento.
   * @private
   */
  setResults(results, pageSize, filtri, state) {
    this.onChangeState({
      ...state,
      filter: filtri,
      loading: false,
      items: results ? results.Items : [],
      totalPages: results ? Math.ceil(results.Count / pageSize) : 0,
      count: results ? results.Count : 0,
    });
  }

  /**
   * Carica la pagina.
   * @public
   */
  loadPage({ url, dataSource }, state) {
    this.onChangeState({ loading: true, selected: false });
    const {
      currentPage, filter, pageSize, sortProperty,
      sortOrder,
    } = state;
    const filtri = [];
    Object.keys(filter).forEach((x) => {
      const filtriProp = filter[x];
      const group = groupBy(filtriProp, 'query');
      Object.keys(group).forEach((z) => {
        const query = resolveFilter(x, group[z]);
        filtri.push(query);
      });
    });

    this.store.salvaStato({
      pageSize,
      currentPage,
      sortProperty,
      sortOrder,
      filtri: filter,
    });

    if (url && typeof (url) === 'string') {
      odata.cerca(
        url,
        pageSize,
        currentPage * pageSize,
        sortProperty,
        sortOrder,
        filtri,
      ).then((results) => {
        this.setResults(results, pageSize, filtri, state);
      });
    }

    if (dataSource && typeof (dataSource) === 'function') {
      const filteredResult = dataSource(pageSize,
        currentPage * pageSize, sortProperty, sortOrder, filtri);
      // verifico se mi viene ritornata una promise
      if (filteredResult.then && typeof filteredResult.then === 'function') {
        filteredResult.then((results) => {
          this.setResults(results, pageSize, filtri, state);
        });
      } else {
        this.setResults(filteredResult, pageSize, filtri, state);
      }
    }
  }
}

export default ODataLoader;
